export function getTypeColor(type) {
  switch (type) {
    case "NON_BANK":
      return "blue";
    case "TRADING_HOUSE":
      return "green";
    default:
      return "default";
  }
}

export function getCurrencyTheme(currency) {
  switch (currency) {
    case "MNT":
      return {
        bg: "#F4E3B2",
        border: "#C89B00",
        accent: "#C89B00",
        iconBg: "#D4A200",
        text: "#111111",
        muted: "#5B5B5B",
      };
    case "USD":
      return {
        bg: "#DDEFE2",
        border: "#2E8B57",
        accent: "#2E8B57",
        iconBg: "#2E8B57",
        text: "#111111",
        muted: "#5B5B5B",
      };
    case "EUR":
      return {
        bg: "#DCE8F8",
        border: "#2563EB",
        accent: "#2563EB",
        iconBg: "#2563EB",
        text: "#111111",
        muted: "#5B5B5B",
      };
    case "CNY":
      return {
        bg: "#F7D6D0",
        border: "#D14334",
        accent: "#D14334",
        iconBg: "#D14334",
        text: "#111111",
        muted: "#5B5B5B",
      };
    default:
      return {
        bg: "#F3F4F6",
        border: "#6B7280",
        accent: "#6B7280",
        iconBg: "#6B7280",
        text: "#111111",
        muted: "#5B5B5B",
      };
  }
}